"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const native_1 = require("@react-navigation/native");
const rootNavigation_1 = require("../../navigation/rootNavigation");
const user_1 = require("../../slices/user");
const useDevice_1 = require("../../hooks/useDevice");
const OutLinedGradientButton_1 = require("../../component/GradientButton/OutLinedGradientButton");
const VStack_1 = __importDefault(require("../../component/ui-components/VStack"));
const AppIcons_1 = require("../../component/AppIcons");
const constants_1 = require("../../common/constants");
const NoCharacterSelected = () => {
    const { isWebDevice, deviceHeight } = (0, useDevice_1.useDevice)();
    const navigation = (0, native_1.useNavigation)();
    const dispatch = (0, react_redux_1.useDispatch)();
    // const { handleCreateNewCharacter } = useCharacter();
    const fbUser = (0, react_redux_1.useSelector)((state) => state.getUserOptions.fbUser);
    const chatQuota = (0, react_redux_1.useSelector)((state) => state.subscriptionPlan?.quota?.conversations);
    const characterQuota = (0, react_redux_1.useSelector)((state) => state.subscriptionPlan.quota.characters);
    const openCharactersList = (0, react_1.useCallback)(async () => {
        if (chatQuota?.quota &&
            chatQuota.quota === chatQuota.consumed &&
            !isWebDevice) {
            if (!fbUser?.uid) {
                dispatch((0, user_1.setUserAction)("signin"));
            }
            else {
                await dispatch((0, user_1.setUserAction)("membership"));
            }
        }
        else {
            navigation.navigate("Home", { screen: "Documents" });
        }
    }, [dispatch, chatQuota, fbUser]);
    const handleNewCharacterRedirect = (0, react_1.useCallback)(async () => {
        if (characterQuota.quota &&
            characterQuota.quota === characterQuota.consumed) {
            if (fbUser && fbUser?.uid) {
                if (isWebDevice) {
                    (0, rootNavigation_1.push)("Pricing");
                }
                else {
                    dispatch((0, user_1.setUserAction)("membership"));
                }
            }
            else {
                if (isWebDevice) {
                    navigation.navigate('LoginPage');
                }
                else {
                    dispatch((0, user_1.setUserAction)("signin"));
                }
            }
        }
        else {
            if (constants_1.SIGN_IN_ENABLED && !fbUser?.uid) {
                if (isWebDevice) {
                    navigation.navigate('LoginPage');
                }
                else {
                    dispatch((0, user_1.setUserAction)("signin"));
                }
            }
            else {
                dispatch((0, user_1.resetCharacter)());
                // navigation.navigate("CharacterPrompt");
            }
        }
    }, [fbUser, characterQuota, isWebDevice, dispatch]);
    return ((0, jsx_runtime_1.jsx)(VStack_1.default, { width: isWebDevice ? undefined : "60%", children: (0, jsx_runtime_1.jsx)(VStack_1.default, { height: deviceHeight, justifyContent: "center", alignContent: "center", alignSelf: "center", textAlign: "center", width: 300, space: 2, children: (0, jsx_runtime_1.jsxs)(VStack_1.default, { space: 4, alignItems: "center", children: [(0, jsx_runtime_1.jsx)(AppIcons_1.NoChat, {}), (0, jsx_runtime_1.jsx)(OutLinedGradientButton_1.OutLinedDarkGradientButton, { text: "Start a New Chat", onPress: openCharactersList, borderWidth: 0 })] }) }) }));
};
exports.default = (0, react_1.memo)(NoCharacterSelected);
